<template>
  <div :class="[containerClass]">
    <label v-if="label" :id="`input-${name}-label`" :for="`input${name}`" :class="[labelClass || 'form-label fs-6 fw-bolder text-black', {isRequired: 'required'}]">
      {{ label }} <span v-if="isRequired" class="text-danger"> * </span>
    </label>
    <div class="input-group">
      <input
        ref="fileInput"
        type="file"
        class="form-control d-none"
        :class="[getClasses(size), inputClass]"
        :name="name"
        :id="`input-${name}`"
        :placeholder="placeholder"
        :required="isRequired"
        :aria-label="label"
        :aria-describedby="`input-${name}-addon`"
        :disabled="isDisabled"
        @change="handleUpload"
      />
      <input
        type="text"
        class="form-control"
        :class="[getClasses(size), inputClass]"
        :name="name"
        :id="`input-${name}`"
        :required="isRequired"
        :aria-label="label"
        :placeholder="placeholder"
        :aria-describedby="`input-${name}-addon`"
        :readonly="true"
        @click="triggerFileInput"
        v-model="fileName"
      />
      <span class="input-group-text icon_class" @click="triggerFileInput">
        <div class="icon-wrapper">
          <i class="far fa-file text-primary" :style="{fontSize: '15px'}"></i>
        </div>
      </span>
    </div>
  </div>
</template>

<script setup>

import { ref, defineModel, defineProps } from 'vue'
import { Theme } from '@/composables/theming';

const model = defineModel()

const props = defineProps( {
  size: {
    type: String,
    default: "default",
  },
  icon: String,
  iconDir: String,
  name: String,
  id: String,
  placeholder: String,
  isRequired: Boolean,
  inputClass: String,
  labelClass: String,
  containerClass: {
    type: String,
    default: 'col-12 mb-10'
  },
  label: String,
  isDisabled: Boolean,
  iconText: String,
  IsInputGroup: Boolean,
  addonClass: String
})

const selector = ref(null)
const fileInput = ref(null)
const fileName = ref('')

async function handleUpload (event) {
  fileName.value = event.target.files[0].name
  model.value = event.target.files[0]
}

function getClasses (size) {
  let sizeValue;
  sizeValue = size ? `form-control-${size}` : null;
  return `${sizeValue}`;
}

function getIcon (icon) {
  return icon ? icon : null
}

function triggerFileInput() {
  fileInput.value.click();
}

</script>

<style scoped>
.icon_class{
  border: 1px dashed var(--bs-primary);
}
.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: 1px;
  padding: 1px 20px;
}
.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: 1px;
  border-top-left-radius: .475rem;
  border-bottom-left-radius: .475rem;
}
.input-group-text{
  background: #0072CE1A;
}
.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 5px;
  background-color: #0072CE33;
  border: 1px solid #0072CE33;
}
</style>
